import { auth } from "@/firebase/firebaseConfig";
import {
  onAuthStateChanged,
  signInWithCustomToken,
  signOut,
  User,
} from "firebase/auth";

const getCurrentFirebaseUser = () =>
  new Promise<User | null>((resolve) => {
    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });

export const ensureFirebaseAuth = async (
  firebaseToken: string | null,
  expectedUid?: string | null
) => {
  const currentUser = await getCurrentFirebaseUser();

  if (currentUser && (!expectedUid || currentUser.uid === expectedUid)) {
    return currentUser;
  }

  if (currentUser && expectedUid && currentUser.uid !== expectedUid) {
    await signOut(auth);
  }

  if (!firebaseToken) {
    throw new Error("Missing Firebase custom token");
  }

  const credential = await signInWithCustomToken(auth, firebaseToken);
  return credential.user;
};
